import React, { FC, Fragment } from 'react'
import { useSelector } from 'react-redux'
import { StyleSheet, View } from 'react-native'
import { color, spacing, fontSize, fontFamily, fontWeight } from '@partipost-cm-new/app-preview/dist/Styles/Base'
import { moderateScale } from '@partipost-cm-new/app-preview/dist/Utils/Scaling'
import Card from '@partipost-cm-new/app-preview/dist/Components/Card'
import PartiText from '@partipost-cm-new/app-preview/dist/Components/PartiText'
import { useNewTranslation } from 'hooks'
import { selectPurchaseFirstStepData, selectPurchaseInterpolationListData } from 'state/appPreview/selector/purchase'
import SubmitPage from '../common/SubmitPage'
import MediaPreview from '../common/MediaPreview'
import PlaceholderComponent from 'components/AppPreview/common/InterpolationList'

const PurchaseProduct: FC = () => {
    const [t] = useNewTranslation()
    const purchaseFirstStepData = useSelector(selectPurchaseFirstStepData)
    const purchaseInterpolationListData = useSelector(selectPurchaseInterpolationListData)

    return (
        <Fragment>
            <SubmitPage stepIndex={'1'} totalStepNumber={'2'} buttonText={t('button.completeStep')}>
                <View style={{ paddingHorizontal: spacing.medium }}>
                    <PartiText>{purchaseFirstStepData.taskTitle}</PartiText>
                    <PartiText style={styles.stepTitle}>{purchaseFirstStepData.stepTitle}</PartiText>
                    <Card cardStyle={styles.container}>
                        <PartiText style={styles.title}>{purchaseFirstStepData.title?.toUpperCase()}</PartiText>
                        <PartiText style={styles.header}>{t('appCampaign.campaignStep.howToBuyHeader')}</PartiText>
                        <PlaceholderComponent
                            template={purchaseInterpolationListData?.howToBuy?.template || ''}
                            values={purchaseInterpolationListData?.howToBuy?.values}
                        />
                    </Card>
                    {purchaseFirstStepData.examplePhotos?.length ? (
                        <MediaPreview files={purchaseFirstStepData.examplePhotos} />
                    ) : null}
                    <MediaPreview />
                </View>
            </SubmitPage>
        </Fragment>
    )
}

const styles = StyleSheet.create({
    campaignCategoryItemContainer: {
        paddingVertical: spacing.extraSmall,
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    stepTitle: {
        fontSize: moderateScale(28),
        fontFamily: fontFamily.title,
        paddingVertical: spacing.small,
    },
    header: {
        fontFamily: fontFamily.title,
        fontSize: fontSize.medium,
        fontWeight: fontWeight.bold,
        paddingTop: spacing.small2,
        paddingBottom: spacing.extraSmall,
    },
    title: {
        fontSize: fontSize.extraSmall,
        paddingBottom: spacing.small,
        color: color.tundora,
        fontFamily: fontFamily.copy,
    },
    footer: { fontSize: fontSize.small, paddingTop: spacing.small },
    container: {
        borderRadius: moderateScale(10),
        padding: spacing.medium,
        margin: 0,
        marginBottom: spacing.medium2,
    },
})

export default PurchaseProduct
